import {Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {Filter} from '../../../models/warranties/filter.model';
import {TabsetComponent} from 'ngx-bootstrap/tabs';
import {HttpService} from '../../../services/http.service';
import {AuthService} from '../../../auth/auth.service';

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ReportComponent implements OnInit {

  filter: Filter = new Filter();
  dealerName: any[] = [];
  dropdownSettings = {};
  @ViewChild('tabset') tabset: TabsetComponent;

  constructor(private http: HttpService, private authService: AuthService) { }
  tabs = [
    // { title: 'CONTRACTS OVERVIEW', content: 'CONTRACTS OVERVIEW' },
    {title: 'WARRANTY SUMMARY', content: 'WARRANTY SUMMARY'},
    // { title: 'DEALER CONTRACT OVERVIEW', content: 'DEALER CONTRACT OVERVIEW' },
    {title: 'DEALER INVOICE SUMMARY', content: 'DEALER INVOICE SUMMARY'},
    {title: 'DEALER CREDIT NOTE SUMMARY', content: 'DEALER CREDIT NOTE SUMMARY'},
    {title: 'DEALER AGE BREAKDOWN', content: 'DEALER AGE BREAKDOWN', active: true},
    {title: 'FULL EXPORT', content: 'FULL EXPORT'},
    {title: 'FAILED UPLOAD EXPORT', content: 'FAILED UPLOAD EXPORT'}
  ];

  ngOnInit(): void {
    this.getDealers();
  }

  isAdmin(): boolean {
    return this.authService.isAdmin();
  }
  getDealers() {
    if (this.authService.isAdmin()) {
      this.http.fetchDealers().subscribe((res) => {
        res.sort((a, b) => (a.dealerName > b.dealerName) ? 1 : -1).forEach((d) => {
          this.dealerName.push(d);
        });
      });
    } else {
      this.http.fetchDealerOptions().subscribe((res) => {
        res.sort((a, b) => (a.dealerName > b.dealerName) ? 1 : -1).forEach((d) => {
          this.dealerName.push(d);
        });
      });
    }
  }
}
